export var ApiResponse;

(function (ApiResponse) {
  ApiResponse[ApiResponse["BadRequest"] = 400] = "BadRequest";
  ApiResponse[ApiResponse["Unauthorized"] = 401] = "Unauthorized";
  ApiResponse[ApiResponse["Forbidden"] = 403] = "Forbidden";
  ApiResponse[ApiResponse["NotFound"] = 404] = "NotFound";
  ApiResponse[ApiResponse["ServerError"] = 500] = "ServerError";
  ApiResponse[ApiResponse["NotImplemented"] = 501] = "NotImplemented";
  ApiResponse[ApiResponse["BadGateway"] = 502] = "BadGateway";
  ApiResponse[ApiResponse["ServiceUnavailable"] = 503] = "ServiceUnavailable";
  ApiResponse[ApiResponse["GatewayTimeout"] = 504] = "GatewayTimeout";
})(ApiResponse || (ApiResponse = {}));

export var ApiResponseStatusText;

(function (ApiResponseStatusText) {
  ApiResponseStatusText["invalid_request"] = "invalid_request";
  ApiResponseStatusText["invalid_token"] = "invalid_token";
  ApiResponseStatusText["insufficient_scope"] = "insufficient_scope";
  ApiResponseStatusText["server_error"] = "server_error";
  ApiResponseStatusText["invalid_grant"] = "invalid_grant";
  ApiResponseStatusText["unauthorized"] = "unauthorized";
})(ApiResponseStatusText || (ApiResponseStatusText = {}));